module.exports = "<div class=\"container justify-content-center pl-5 pr-5 mt-5\">\r\n  <article [innerHTML]=\"gdprText\">\r\n    \r\n  </article>\r\n</div>"